export default "__VITE_ASSET__DZ_zQ0$i__"